import React, { useEffect } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { CheckboxDescription, CheckboxLabel, CheckboxWrapper, Field, OptionsContainer, RateDisplay, ZoomLabel, ZoomWrapper } from '../../styles/login.style';
import { ProfilePatch } from '../../hooks/auth.service';
import { styled } from '../../styles/stitches.config';
import { RateHint } from '../../components/register/InfoBlock';
import { CustomCheckbox } from '../../components/messenger/CustomCheckbox';



// --- COMPONENT ---
interface Props {
  data: ProfilePatch;
  onChange: (d: ProfilePatch) => void;
  onValidityChange?: (ok: boolean) => void;
}

const RateStep: React.FC<Props> = ({ data, onChange, onValidityChange }) => {
    const currentRate = data.hourlyRate ?? 30;
  
    useEffect(() => {
      const defaults: Partial<ProfilePatch> = {};
      if (data.hourlyRate === undefined) {
        defaults.hourlyRate = 30;
      }
      if (data.offersFreeIntroCall === undefined) {
        defaults.offersFreeIntroCall = true;
      }
      if (Object.keys(defaults).length > 0) {
          onChange({ ...data, ...defaults });
      }
      onValidityChange?.(true);
    }, [data, onChange, onValidityChange]);

    const handleSliderChange = (value: number | number[]) => {
        if (typeof value === 'number') {
            onChange({ ...data, hourlyRate: value });
        }
    };

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = event.target;
        onChange({ ...data, [name]: checked });
    };

  return (
    <Field name="hourlyRate">
        <RateHint/>
      <ZoomWrapper css={{marginTop: '1.5rem',}}>
        <ZoomLabel>Adjust Rate (£25-£50)</ZoomLabel>
        <Slider
          min={25}
          max={50}
          step={1}
          value={currentRate}
          onChange={handleSliderChange}
          styles={{
            // track: { backgroundColor: '#2563eb', height: '6px' },
            // rail: { backgroundColor: '#d1d5db', height: '6px' },
            handle: {
            //   borderColor: '#2563eb',
              height: 20,
              width: 20,
              marginTop: -7,
              backgroundColor: 'white',
              opacity: 1,
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            },
          }}
        />
      </ZoomWrapper>

      <RateDisplay>£{currentRate} / hour</RateDisplay>

      <OptionsContainer>
                <CheckboxWrapper>
                    <CustomCheckbox                         
                        checked={!!data.offersFreeFirstLesson}
                        onChange={() => onChange({ ...data, offersFreeFirstLesson: !data.offersFreeFirstLesson })}
                        />

                    {/* <CheckboxInput
                        type="checkbox"
                        name="offersFreeFirstLesson"
                        checked={!!data.offersFreeFirstLesson}
                        onChange={handleCheckboxChange}
                    /> */}
                    <CheckboxLabel>Offer first hour free</CheckboxLabel>
                </CheckboxWrapper>

                <CheckboxWrapper>

                <CustomCheckbox                         
                        checked={!!data.offersFreeIntroCall}
                        onChange={() => onChange({ ...data, offersFreeIntroCall: !data.offersFreeIntroCall })}
                        />
                    {/* <CheckboxInput
                        type="checkbox"
                        name="offersFreeIntroCall"
                        checked={!!data.offersFreeIntroCall}
                        onChange={handleCheckboxChange}
                    /> */}
                    <CheckboxLabel>Offer a free 15-min intro call</CheckboxLabel>
                    <CheckboxDescription>Recommended</CheckboxDescription>
                </CheckboxWrapper>
            </OptionsContainer>

    </Field>
  );
};

export default RateStep;